export default function zip3Map(zip3Json) {
  let idNameMap = new Map()
  zip3Json['features'].forEach((value) => {
    idNameMap[value.properties['geoid']] = value.properties['geoid']
  })
  return idNameMap
}
